import Axios from 'axios';
import formatISO from 'date-fns/formatISO';
import qs from 'qs';

import * as shs from './schemas';

export class LunaPointClient {
  constructor(baseUrl = '') {
    this.baseUrl = baseUrl;
    this.http = Axios.create({
      baseURL: this.baseUrl,
      paramsSerializer: (params) => qs.stringify(params, {
        arrayFormat: 'comma',
        serializeDate: formatISO,
      }),
    });
  }

  get cards() {
    return {
      get: (params = undefined) => {
        return this.http.get('/cards', { params: shs.getCardsQs(params) });
      },
      post: (payload) => this.http.post('/cards', payload),
    };
  }

  card(cardId) {
    return {
      get: (params = undefined) => this.http.get(`/cards/${cardId}`, { params }),
      put: (payload) => this.http.put(`/cards/${cardId}`, payload),
      patch: (payload) => this.http.patch(`/cards/${cardId}`, payload),
      delete: () => this.http.delete(`/cards/${cardId}`),
      files: {
        get: () => this.http.get(`/cards/${cardId}/files`),
        post: (payload) => this.http.post(`/cards/${cardId}/files`, payload),
      },
    };
  }

  file(fileId) {
    return {
      get: () => this.http.get(`/files/${fileId}`),
      delete: () => this.http.delete(`/files/${fileId}`),
    };
  }

  get vms() {
    return {
      vendor: (vendor) => ({
        getAll: () => this.http.get('/vms/sources'),
        updateAll: () => this.http.post('/vms/sources/update'),
        get: () => this.http.get(`/vms/${vendor}/sources`),
        post: () => this.http.post(`/vms/${vendor}/sources/update`),
        source: (uuid) => ({
          patch: (payload) => this.http.patch(`/vms/${vendor}/sources/${uuid}`, payload),
          proxy: async (params) => {
            const response = await this.http.get(`/vms/${vendor}/sources/${uuid}/proxy`, { params });

            if (response.data?.ws && response.data.ws.startsWith('/')) {
              response.data.uiWsUrl = `${this.baseUrl}${response.data.ws}`;
            }

            return response;
          },
        }),
      }),
    };
  }
}
